(() => {
  const root = document.documentElement;

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 18);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const direction = button.dataset.quantityAction === 'increase' ? 1 : -1;
        const min = Number(input.min || 1);
        const max = Number(input.max || Infinity);
        input.value = String(Math.min(max, Math.max(min, Number(input.value || min) + direction)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const form = productRoot.querySelector('.product-form');
    const selector = productRoot.querySelector('[data-variant-select]');
    const price = productRoot.querySelector('[data-product-price]');
    const submit = productRoot.querySelector('[data-add-to-cart]');
    const status = productRoot.querySelector('[data-product-add-status]');
    let resetTimer;

    const syncProductVariant = () => {
      if (!selector || !submit) return;
      const option = selector.options[selector.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      const available = option?.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
    };

    selector?.addEventListener('change', () => {
      window.clearTimeout(resetTimer);
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }
      syncProductVariant();
    });
    syncProductVariant();

    form?.addEventListener('submit', async (event) => {
      if (!window.fetch || !submit || submit.disabled) return;
      event.preventDefault();
      window.clearTimeout(resetTimer);

      const rootUrl = window.Shopify?.routes?.root || '/';
      submit.disabled = true;
      submit.classList.add('is-loading');
      submit.textContent = submit.dataset.addingLabel || 'ADDING…';
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }

      try {
        const addResponse = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        const addedItem = await addResponse.json();
        if (!addResponse.ok) throw new Error(addedItem.description || addedItem.message || 'This item could not be added to your bag.');

        const cartResponse = await fetch(`${rootUrl}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        let cartData = null;
        if (cartResponse.ok) {
          cartData = await cartResponse.json();
          updateCartCount(cartData);
        }

        submit.classList.remove('is-loading');
        submit.classList.add('is-added');
        submit.textContent = submit.dataset.addedLabel || 'ADDED TO BAG';
        if (status) status.textContent = `${addedItem.product_title || addedItem.title || 'Item'} added to your bag.`;
        const liveRegion = document.getElementById('ThemeLiveRegion');
        if (liveRegion) liveRegion.textContent = status?.textContent || 'Item added to your bag.';
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: addedItem, cart: cartData, openDrawer: true } }));

        resetTimer = window.setTimeout(() => {
          submit.classList.remove('is-added');
          if (selector) syncProductVariant();
          else {
            submit.disabled = false;
            submit.textContent = submit.dataset.availableLabel || 'ADD TO BAG';
          }
        }, 1800);
      } catch (error) {
        submit.classList.remove('is-loading', 'is-added');
        if (status) {
          status.textContent = error.message || 'This item could not be added to your bag.';
          status.classList.add('is-error');
        }
        if (selector) syncProductVariant();
        else {
          submit.disabled = false;
          submit.textContent = submit.dataset.availableLabel || 'ADD TO BAG';
        }
      }
    });
  });

  const updateCartCount = (cart) => {
    const itemCount = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = String(itemCount);
    });
    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      const label = link.dataset.cartLabel || 'Bag';
      link.setAttribute('aria-label', `${label} with ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
    });
  };

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  let cartDrawerTrigger = null;
  let cartDrawerCloseTimer;

  const formatCartMoney = (amount, currency) => {
    const activeCurrency = currency || window.Shopify?.currency?.active || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: activeCurrency,
        currencyDisplay: 'symbol'
      }).format(Number(amount || 0) / 100);
    } catch (_error) {
      return `${(Number(amount || 0) / 100).toFixed(2)} ${activeCurrency}`;
    }
  };

  const renderCartDrawer = (cart, justAdded = false) => {
    if (!cartDrawer || !cart) return;

    const itemsRoot = cartDrawer.querySelector('[data-cart-drawer-items]');
    const emptyState = cartDrawer.querySelector('[data-cart-drawer-empty]');
    const footer = cartDrawer.querySelector('[data-cart-drawer-footer]');
    const total = cartDrawer.querySelector('[data-cart-drawer-total]');
    const title = cartDrawer.querySelector('[data-cart-drawer-title]');
    const itemCount = Number(cart.item_count || 0);

    if (title) title.textContent = justAdded ? 'ADDED TO BAG' : 'YOUR BAG';
    if (emptyState) emptyState.hidden = itemCount > 0;
    if (itemsRoot) itemsRoot.hidden = itemCount === 0;
    if (footer) footer.hidden = itemCount === 0;
    if (total) total.textContent = formatCartMoney(cart.total_price, cart.currency);
    if (!itemsRoot) return;

    itemsRoot.replaceChildren();
    (cart.items || []).forEach((item) => {
      const row = document.createElement('article');
      row.className = 'cart-drawer__item';

      const productUrl = item.url || `${window.Shopify?.routes?.root || '/'}cart`;
      if (item.image) {
        const imageLink = document.createElement('a');
        imageLink.className = 'cart-drawer__image';
        imageLink.href = productUrl;
        const productImage = document.createElement('img');
        productImage.src = item.image;
        productImage.alt = item.product_title || item.title || 'Product';
        productImage.loading = 'lazy';
        imageLink.appendChild(productImage);
        row.appendChild(imageLink);
      } else {
        const imagePlaceholder = document.createElement('div');
        imagePlaceholder.className = 'cart-drawer__image cart-drawer__image--empty';
        imagePlaceholder.setAttribute('aria-hidden', 'true');
        row.appendChild(imagePlaceholder);
      }

      const copy = document.createElement('div');
      copy.className = 'cart-drawer__item-copy';
      const productLink = document.createElement('a');
      productLink.className = 'cart-drawer__item-title';
      productLink.href = productUrl;
      productLink.textContent = item.product_title || item.title || 'Product';
      copy.appendChild(productLink);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.textContent = item.variant_title;
        copy.appendChild(variant);
      }

      const quantity = document.createElement('p');
      quantity.textContent = `QTY ${Number(item.quantity || 0)}`;
      copy.appendChild(quantity);
      row.appendChild(copy);

      const linePrice = document.createElement('strong');
      linePrice.className = 'cart-drawer__item-price';
      linePrice.textContent = formatCartMoney(item.final_line_price ?? item.line_price, cart.currency);
      row.appendChild(linePrice);
      itemsRoot.appendChild(row);
    });
  };

  const fetchCart = async () => {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Your bag could not be loaded.');
    return response.json();
  };

  const showCartDrawer = (cart, trigger, justAdded = false) => {
    if (!cartDrawer) return;
    window.clearTimeout(cartDrawerCloseTimer);
    cartDrawerTrigger = trigger || document.activeElement;
    renderCartDrawer(cart, justAdded);
    cartDrawer.hidden = false;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    window.requestAnimationFrame(() => {
      cartDrawer.classList.add('is-open');
      cartDrawer.querySelector('.cart-drawer__close')?.focus();
    });
  };

  const closeCartDrawer = () => {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    cartDrawerCloseTimer = window.setTimeout(() => {
      cartDrawer.hidden = true;
      if (cartDrawerTrigger instanceof HTMLElement) cartDrawerTrigger.focus();
    }, 280);
  };

  document.addEventListener('cart:updated', async (event) => {
    if (!cartDrawer || !event.detail?.openDrawer) return;
    try {
      const cart = event.detail.cart || await fetchCart();
      showCartDrawer(cart, document.activeElement, true);
    } catch (_error) {
      // The inline product status remains visible if the cart refresh fails.
    }
  });

  document.addEventListener('click', async (event) => {
    const bagLink = event.target.closest('[data-cart-link]');
    if (bagLink && cartDrawer && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      try {
        const cart = await fetchCart();
        updateCartCount(cart);
        showCartDrawer(cart, bagLink, false);
      } catch (_error) {
        window.location.assign(bagLink.href);
      }
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartDrawer && !cartDrawer.hidden) closeCartDrawer();
  });

  const initDropProductForms = (scope = document) => {
    const forms = [];
    if (scope instanceof Element && scope.matches('.drop-card__form')) forms.push(scope);
    forms.push(...scope.querySelectorAll('.drop-card__form'));

    forms.forEach((form) => {
      if (form.dataset.dropFormReady === 'true') return;
      form.dataset.dropFormReady = 'true';

      const card = form.closest('.drop-card, .catalogue-card');
      const selector = form.querySelector('[data-drop-variant-select]');
      const price = card?.querySelector('.drop-card__price, .catalogue-card__price');
      const submit = form.querySelector('[data-drop-add-to-cart]');
      const status = form.querySelector('[data-drop-add-status]');
      let resetTimer;

      const syncVariant = () => {
        if (!selector || !submit) return;
        const option = selector.options[selector.selectedIndex];
        const available = option?.dataset.available === 'true';
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
      };

      selector?.addEventListener('change', () => {
        window.clearTimeout(resetTimer);
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }
        syncVariant();
      });
      syncVariant();

      form.addEventListener('submit', async (event) => {
        if (!window.fetch || !submit || submit.disabled) return;
        event.preventDefault();
        window.clearTimeout(resetTimer);

        const rootUrl = window.Shopify?.routes?.root || '/';
        submit.disabled = true;
        submit.classList.add('is-loading');
        submit.textContent = submit.dataset.addingLabel || 'ADDING…';
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          const addResponse = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });
          const addedItem = await addResponse.json();
          if (!addResponse.ok) throw new Error(addedItem.description || addedItem.message || 'This item could not be added to your bag.');

          const cartResponse = await fetch(`${rootUrl}cart.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          let cartData = null;
          if (cartResponse.ok) {
            cartData = await cartResponse.json();
            updateCartCount(cartData);
          }

          submit.classList.remove('is-loading');
          submit.classList.add('is-added');
          submit.textContent = submit.dataset.addedLabel || 'ADDED TO BAG';
          if (status) status.textContent = `${addedItem.product_title || addedItem.title || 'Item'} added to your bag.`;
          const liveRegion = document.getElementById('ThemeLiveRegion');
          if (liveRegion) liveRegion.textContent = status?.textContent || 'Item added to your bag.';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: addedItem, cart: cartData, openDrawer: true } }));

          resetTimer = window.setTimeout(() => {
            submit.classList.remove('is-added');
            syncVariant();
          }, 1800);
        } catch (error) {
          submit.classList.remove('is-loading', 'is-added');
          if (status) {
            status.textContent = error.message || 'This item could not be added to your bag.';
            status.classList.add('is-error');
          }
          submit.disabled = false;
          syncVariant();
        }
      });
    });
  };

  initDropProductForms();

  document.querySelectorAll('[data-gallery-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const gallery = thumbnail.closest('[data-product-gallery]');
      const mainImage = gallery?.querySelector('[data-gallery-main]');
      if (!mainImage || !thumbnail.dataset.imageSrc) return;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = '';
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => item.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
    });
  });

  const sizeGuideDrawer = document.querySelector('[data-size-guide-drawer]');
  let sizeGuideTrigger = null;

  const openSizeGuide = (trigger) => {
    if (!sizeGuideDrawer) return;
    sizeGuideTrigger = trigger || document.activeElement;
    sizeGuideDrawer.hidden = false;
    document.body.classList.add('size-guide-drawer-open');
    window.requestAnimationFrame(() => {
      sizeGuideDrawer.classList.add('is-open');
      sizeGuideDrawer.querySelector('.size-guide-drawer__close')?.focus();
    });
  };

  const closeSizeGuide = () => {
    if (!sizeGuideDrawer || sizeGuideDrawer.hidden) return;
    sizeGuideDrawer.classList.remove('is-open');
    document.body.classList.remove('size-guide-drawer-open');
    window.setTimeout(() => {
      sizeGuideDrawer.hidden = true;
      if (sizeGuideTrigger instanceof HTMLElement) sizeGuideTrigger.focus();
    }, 260);
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-size-guide-open]');
    if (openTrigger) {
      event.preventDefault();
      openSizeGuide(openTrigger);
      return;
    }
    if (event.target.closest('[data-size-guide-close]')) {
      event.preventDefault();
      closeSizeGuide();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sizeGuideDrawer && !sizeGuideDrawer.hidden) closeSizeGuide();
  });

  if (window.location.hash === '#size-guide') window.setTimeout(() => openSizeGuide(), 0);

  const designMode = Boolean(window.Shopify?.designMode) || root.classList.contains('shopify-design-mode');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = (scope = document) => Array.from(scope.querySelectorAll('[data-reveal]'));
  const showItems = (items) => items.forEach((item) => item.classList.add('is-visible'));

  if (designMode) {
    root.classList.add('shopify-design-mode');
    root.dataset.reveal = 'false';
  }

  let observer;
  if (root.dataset.reveal === 'true' && !reducedMotion && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.04, rootMargin: '0px 0px 12% 0px' });
    revealItems().forEach((item) => observer.observe(item));

    // Content must never remain hidden if an embedded browser delays the observer.
    window.setTimeout(() => showItems(revealItems()), 1800);
  } else {
    showItems(revealItems());
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDropProductForms(event.target);
    const items = revealItems(event.target);
    if (designMode || !observer) showItems(items);
    else items.forEach((item) => observer.observe(item));
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('[data-size-guide-drawer]')) openSizeGuide();
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector('[data-size-guide-drawer]')) closeSizeGuide();
  });

  document.addEventListener('shopify:section:reorder', () => showItems(revealItems()));
})();
